module.exports = __webpack_public_path__ + "media/svg-new/button-right-blue-5bf1175c.svg";